/* eslint-disable no-unused-vars */
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { generalActions } from 'store/campaign/general';
import { formErrorsCampaign_action } from 'store/campaign/formErrors';
import { areDatesEqual, formatDate, increaseTime, hasPastDuplicateSchedule } from 'utils';

const convertDate = ({ date, environment }) => {
  return !date ? null : new Date((new Date(date) + 'UTC').toLocaleString());
};

const getFixedTimezoneOffset = (date) => {
  //const janOffset = Math.abs(new Date(date.getFullYear(), 0, 1).getTimezoneOffset());
  //const julOffset = Math.abs(new Date(date.getFullYear(), 6, 1).getTimezoneOffset());
  const currentOffset = Math.abs(new Date(date).getTimezoneOffset());
  return currentOffset / 60;
  //return Math.max(janOffset, julOffset) / 60;
};

const toUTC = (localDate) => {
  const fixedOffsetHours = getFixedTimezoneOffset(localDate);
  const res = new Date(localDate.getTime() - fixedOffsetHours * 3600000);
  return res;
};

export const useFacade = (environment) => {
  const dispatch = useDispatch();
  const campaign = useSelector((state) => state.general?.mainCampaignObject?.currentCampaignObj);
  const startDateError = hasPastDuplicateSchedule(
    { schedulerStartDate: campaign?.schedulerStartDate },
    environment,
  );
  const endDateError = hasPastDuplicateSchedule(
    { schedulerEndDate: campaign?.schedulerEndDate },
    environment,
  );
  const schedulerError = startDateError || endDateError;

  useEffect(() => {
    dispatch(
      formErrorsCampaign_action.updateErrorField({
        errorField: 'general',
        newValue: schedulerError,
      }),
    );
  }, [dispatch, schedulerError]);

  const handleUpdatePicker = useCallback((value, field) => {
    const newDate = value ? formatDate(value) : null;
    dispatch(
      generalActions.updateCurrentCampaignObj({
        propField: field,
        newValue: newDate,
      }),
    );
  }, []);

  let startDate = useSelector((state) => {
    //const startDate = state.general?.mainCampaignObject?.currentCampaignObj?.schedulerStartDate;
    //if (!startDate) return null;
    //return new Date(startDate);
    return state.general?.mainCampaignObject?.currentCampaignObj?.schedulerStartDate;
  });

  //startDate = !startDate ? null : new Date(startDate);

  //startDate = !startDate ? null : new Date((new Date(startDate) + 'UTC').toLocaleString());

  startDate = convertDate({ date: startDate, environment });

  let endDate = useSelector((state) => {
    // const endDate = state.general?.mainCampaignObject?.currentCampaignObj?.schedulerEndDate;
    // if (!endDate) return null;
    // return new Date(endDate);
    return state.general?.mainCampaignObject?.currentCampaignObj?.schedulerEndDate;
  });

  //endDate = !endDate ? null : new Date(endDate);

  //endDate = !endDate ? null : new Date((new Date(endDate) + 'UTC').toLocaleString());

  endDate = convertDate({ date: endDate, environment });

  const disabledPicker = useCallback(
    (value) => {
      if (environment === 'edit') {
        if (!value) return false;
        if (!value && value === endDate && startDate) {
          return false;
        } else if (!value && value === startDate && endDate >= new Date()) {
          return false;
        }
        return value < new Date();
      }
    },
    [environment],
  );

  const checkAndClearEndDate = useCallback(
    (value, currentField) => {
      if (currentField === 'schedulerStartDate' && endDate && endDate <= value) {
        handleUpdatePicker(null, 'schedulerEndDate');
      }
    },
    [endDate],
  );

  const handleChangeDate = useCallback(
    (value, field) => {
      const currentDate = new Date();
      const newDate = value;
      if (areDatesEqual(value, currentDate) || (startDate && areDatesEqual(value, startDate))) {
        if (field === 'schedulerEndDate' && startDate) {
          const startHour =
            startDate > currentDate ? startDate.getHours() : minStartTime.getHours();
          newDate.setHours(startHour + 1);
        } else if (currentDate.getMinutes() > 0) {
          newDate.setHours(currentDate.getHours() + 1);
        }
      } else {
        newDate.setHours(0);
      }
      newDate.setMinutes(0);
      const utcTime = toUTC(newDate);
      handleUpdatePicker(utcTime, field);
      checkAndClearEndDate(utcTime, field);
    },
    [checkAndClearEndDate, startDate],
  );

  const handleChangeTime = useCallback(
    (value, field) => {
      const utcTime = toUTC(value);
      handleUpdatePicker(utcTime, field);
      checkAndClearEndDate(utcTime, field);
    },
    [checkAndClearEndDate],
  );

  const minStartTime = useMemo(() => {
    if (!startDate) return null;
    const current = new Date();
    if (startDate && startDate > current) {
      const currDate = current.getDate();
      const currMounth = current.getMonth();
      const currYear = current.getFullYear();
      const selectDate = startDate.getDate();
      const selectMounth = startDate.getMonth();
      const selectYear = startDate.getFullYear();
      if (selectYear === currYear && selectMounth === currMounth && selectDate === currDate) {
        return current;
      }
      const date = new Date();
      date.setHours(0);
      date.setMinutes(0);
      return date;
    } else {
      current.setMinutes(0);
      return current;
    }
  }, [startDate]);

  const minEndTime = useMemo(() => {
    if ((!startDate && !endDate) || (startDate && !endDate)) {
      return new Date();
    }
    if (!startDate && endDate) {
      const dateWithZeroHours = new Date();
      dateWithZeroHours.setHours(0, 0, 0, 0);
      const newDate = areDatesEqual(endDate, new Date())
        ? increaseTime(new Date())
        : dateWithZeroHours;
      return newDate;
    }
    if (startDate && areDatesEqual(startDate, new Date()) && endDate) {
      const dateWithZeroHours = new Date();
      dateWithZeroHours.setHours(0, 0, 0, 0);
      const newDate = areDatesEqual(endDate, new Date())
        ? increaseTime(startDate)
        : dateWithZeroHours;
      return newDate;
    }
    if (startDate && !areDatesEqual(startDate, new Date()) && endDate) {
      if (startDate > new Date()) {
        const dateWithZeroHours = new Date();
        dateWithZeroHours.setHours(0, 0, 0, 0);
        const newDate = areDatesEqual(endDate, startDate)
          ? increaseTime(startDate)
          : dateWithZeroHours;
        return newDate;
      } else {
        const dateWithZeroHours = new Date();
        dateWithZeroHours.setHours(0, 0, 0, 0);
        const newDate = areDatesEqual(endDate, new Date())
          ? increaseTime(new Date())
          : dateWithZeroHours;
        return newDate;
      }
    }
  }, [minStartTime, endDate, startDate]);

  const maxStartTime = new Date();
  maxStartTime.setHours(23);
  maxStartTime.setMinutes(0);

  const minDateForStartCalendar = useMemo(() => {
    const minStartDate = new Date();
    if (minStartDate.getMinutes() > 0) {
      minStartDate.setHours(minStartDate.getHours() + 1);
    }
    minStartDate.setMinutes(0);
    return minStartDate;
  }, []);

  const onStartCalendarOpen = useCallback(
    (fieldName) => {
      if (startDate >= minDateForStartCalendar && startDate < endDate) return;
      if (!startDate || (startDate && startDate < minDateForStartCalendar)) {
        dispatch(
          generalActions.updateCurrentCampaignObj({
            propField: fieldName,
            newValue: formatDate(minDateForStartCalendar),
          }),
        );
        if (endDate > new Date() && endDate > minDateForStartCalendar) return;
        const dateForEndCalendar = new Date(minDateForStartCalendar);
        dateForEndCalendar.setHours(dateForEndCalendar.getHours() + 1);
        dispatch(
          generalActions.updateCurrentCampaignObj({
            propField: 'schedulerEndDate',
            newValue: formatDate(dateForEndCalendar),
          }),
        );
      }
    },
    [startDate],
  );

  const onEndCalendarOpen = useCallback(
    (fieldName) => {
      if (endDate < new Date()) {
        const date = new Date();
        date.setHours(date.getHours() + 1);
        date.setMinutes(0);
        dispatch(
          generalActions.updateCurrentCampaignObj({
            propField: fieldName,
            newValue: formatDate(date),
          }),
        );
        return;
      }
      if (!endDate || (endDate && endDate < startDate)) {
        const date = new Date(startDate);
        date.setHours(date.getHours() + 1);
        dispatch(
          generalActions.updateCurrentCampaignObj({
            propField: fieldName,
            newValue: formatDate(date),
          }),
        );
      }
    },
    [startDate],
  );

  return {
    startDateError,
    endDateError,
    onEndCalendarOpen,
    onStartCalendarOpen,
    startDateFromServer: startDate,
    endDateFromServer: endDate,
    minDateForStartCalendar,
    handleChangeDate,
    maxStartTime,
    minStartTime,
    minEndTime,
    handleChangeTime,
    disabledPicker,
    handleUpdatePicker,
  };
};
